import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PropertySearchCardVM } from '../../../models/property-search-card.vm';

/**
 * Carrusel "Descubre más Propiedades". Presentacional: recibe las cards
 * (reusa el VM de búsqueda del Slice 1) y reemite el id seleccionado.
 * UI con `p-carousel` + el shared `app-property-card`.
 */
@Component({
    selector: 'app-related-properties',
    templateUrl: './related-properties.component.html',
    styleUrls: ['./related-properties.component.scss'],
})
export class RelatedPropertiesComponent {
    @Input() properties: PropertySearchCardVM[] = [];
    @Output() select = new EventEmitter<number>();

    readonly responsiveOptions = [
        { breakpoint: '1199px', numVisible: 3, numScroll: 1 },
        { breakpoint: '991px', numVisible: 2, numScroll: 1 },
        { breakpoint: '767px', numVisible: 1, numScroll: 1 },
    ];
}
